import React, { useEffect, useState, useRef } from "react";
import { Form, Container, Row, Col, Card } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  addDayHotel,
  getDayPlan,
  getoptions,
} from "../../store/slices/package";
import { getPlace } from "../../store/slices/place";
import { gettravelHotel } from "../../store/slices/travelhotel";
import { getroomType } from "../../store/slices/roomtype";
import { toast } from "react-toastify";
import Select from "react-select";


export default function CopyHotelStep({
  packageId,
  hotels,
  setHotels,
  nextStep,
  prevStep,
}) {
  const dispatch = useDispatch();
  const hasLoaded = useRef(false);
  const [dayPlans, setDayPlans] = useState([]);
  const [options, setOptions] = useState([]);
  const [roomTypesMap, setRoomTypesMap] = useState({});
  const [hotelsMap, setHotelsMap] = useState({});
  const [places, setPlaces] = useState([]);


  const [errors, setErrors] = useState([]);

  useEffect(() => {
    if (!packageId) return;

    const fetchData = async () => {
      try {
        const item = { packageId };

        const dpRes = await dispatch(getDayPlan(item)).unwrap();
        const optRes = await dispatch(getoptions(item)).unwrap();
        // const hotelRes = await dispatch(gettravelHotel()).unwrap();
        const placeRes = await dispatch(getPlace()).unwrap();

        const dp = dpRes?.data || [];
        const opt = optRes?.data || [];

        setDayPlans(dp);
        setOptions(opt);
        // setTravelHotels(hotelRes?.hotels || []);
        setPlaces(placeRes?.places || placeRes?.data || []);
      } catch (err) {
        toast.error("Failed to load hotel data");
      }
    };

    fetchData();
  }, [packageId, dispatch]);

  useEffect(() => {
    if (hasLoaded.current) return;

    if (!hotels.length) return;

    hasLoaded.current = true;

    const loadEditHotels = async () => {
      for (let i = 0; i < hotels.length; i++) {
        const config = hotels[i];

        if (config.place) {
          const hotelRes = await dispatch(
            gettravelHotel({ location: config.place })
          ).unwrap();

          setHotelsMap((prev) => ({
            ...prev,
            [i]: hotelRes?.hotels || [],
          }));
        }

        if (config.hotel) {
          const roomRes = await dispatch(
            getroomType({ hotelId: config.hotel })
          ).unwrap();

          setRoomTypesMap((prev) => ({
            ...prev,
            [i]: roomRes?.rooms || [],
          }));
        }
      }
    };

    loadEditHotels();
  }, [hotels]);

  useEffect(() => {

    if (
      !options.length ||
      !dayPlans.length
    ) return;

    setHotels((prevHotels) => {

      if (prevHotels.length > 0) {
        const updatedHotels = prevHotels.map((hotel, idx) => ({
          _id: hotel._id || null,
          ...hotel,
          packageOption:
            options.find(
              (_, i) =>
                i === Math.floor(idx / (dayPlans.length - 1))
            )?._id || hotel.packageOption,

          dayPlan:
            dayPlans[
              idx % (dayPlans.length - 1)
            ]?._id || hotel.dayPlan,
        }));

        const stayDays = dayPlans.slice(0, dayPlans.length - 1);

        options.forEach((option) => {
          stayDays.forEach((day) => {

            const exists = updatedHotels.some(
              (h) =>
                String(h.packageOption) === String(option._id) &&
                String(h.dayPlan) === String(day._id)
            );

            if (!exists) {
              updatedHotels.push({
                _id: null,
                packageOption: option._id,
                dayPlan: day._id,
                place: "",
                hotel: "",
                roomType: "",
                nights: 1,
                rooms: 1,
                extraBeds: 0,
                roomPrice: 0,
                extraBedPrice: 0,
                addons: [],
                meals: {
                  breakfast: false,
                  lunch: false,
                  dinner: false,
                },
              });
            }
          });
        });

        return updatedHotels;
      }

      let generated = [];

      const stayDays =
        dayPlans.slice(
          0,
          dayPlans.length - 1
        );

      options.forEach(
        (option) => {

          stayDays.forEach(
            (day) => {

              generated.push({
                _id: null,
                packageOption: option._id,
                dayPlan: day._id,
                place: "",
                hotel: "",
                roomType: "",
                nights: 1,
                rooms: 1,
                extraBeds: 0,
                roomPrice: 0,
                extraBedPrice: 0,
                addons: [],
                meals: {
                  breakfast: false,
                  lunch: false,
                  dinner: false,
                },
              });
            }
          );
        }
      );

      return generated;
    });

  }, [options, dayPlans,]);


  const handleRemoveHotel = (index) => {
    const updated = [...hotels];

    updated[index] = {
      ...updated[index],
      isRemoved: true,
      _id: null,
      place: "",
      hotel: "",
      roomType: "",
      nights: 1,
      rooms: 1,
      extraBeds: 0,
      roomPrice: 0,
      extraBedPrice: 0,
      meals: {
        breakfast: false,
        lunch: false,
        dinner: false,
      },
    };

    setHotels(updated);

    const updatedErrors = [...errors];
    updatedErrors[index] = {};
    setErrors(updatedErrors);

    toast.success("Hotel removed");
  };

  const handleChange = async (index, field, value) => {
    const updated = [...hotels];
    const newErrors = [...errors];

    if (!newErrors[index]) newErrors[index] = {};

    if (field === "place") {
      updated[index].place = value;
      updated[index].hotel = "";
      updated[index].roomType = "";
      updated[index].roomPrice = 0;
      updated[index].extraBedPrice = 0;

      setRoomTypesMap((prev) => ({
        ...prev,
        [index]: [],
      }));

      if (value) {
        try {
          const hotelRes = await dispatch(
            gettravelHotel({ location: value }),
          ).unwrap();

          setHotelsMap((prev) => ({
            ...prev,
            [index]: hotelRes?.hotels || [],
          }));
        } catch (err) {
          toast.error("Failed to load hotels");
        }
      }

      setHotels(updated);
      return;
    }
    if (field === "place") {
      if (!value) {
        newErrors[index].place = "Please select place";
      } else {
        newErrors[index].place = "";
      }
    }

    if (field === "hotel") {
      if (!value) {
        newErrors[index].hotel = "Please select hotel";
      } else {
        newErrors[index].hotel = "";
      }
    }

    if (field === "roomType") {
      if (!value) {
        newErrors[index].roomType = "Please select room type";
      } else {
        newErrors[index].roomType = "";
      }
    }
    if (field === "roomType") {
      updated[index].roomType = value;

      const room = (roomTypesMap[index] || []).find(
        (r) => r._id === value
      );

      if (room) {
        updated[index].roomPrice = room.basePrice || 0;
        updated[index].extraBedPrice = room.extraBedPrice || 0;

        // Start with no selected addons
        updated[index].addons = [];
      }

      setHotels(updated);
      setErrors(newErrors);
      return;
    }

    if (field === "roomPrice") {
      updated[index].roomPrice = value === "" ? "" : Number(value);

      setHotels(updated);
      setErrors(newErrors);
      return;
    }



    updated[index][field] = value;

    setHotels(updated);
    setErrors(newErrors);

    if (field === "hotel" && value) {
      try {
        const roomRes = await dispatch(
          getroomType({ hotelId: value }),
        ).unwrap();

        setRoomTypesMap((prev) => ({
          ...prev,
          [index]: roomRes?.rooms || [],
        }));
      } catch (err) {
        toast.error("Failed to load room types");
      }
    }
  };

  const validateHotelSubmit = () => {
    let isValid = true;

    const newErrors = hotels.map((config) => {
      const errorObj = {};

      // If no hotel is selected, this day was intentionally removed.
      // Don't validate it.
      if (!config.hotel) {
        return errorObj;
      }

      if (!config.place) {
        errorObj.place = "Please select place";
        isValid = false;
      }

      if (!config.roomType) {
        errorObj.roomType = "Please select room type";
        isValid = false;
      }

      if (!config.nights || config.nights < 1 || config.nights > 21) {
        errorObj.nights = "Nights must be 1 - 30";
        isValid = false;
      }

      if (!config.roomPrice || config.roomPrice <= 0) {
        errorObj.roomPrice = "Please enter room price";
        isValid = false;
      }

      if (!config.rooms || config.rooms < 1 || config.rooms > 6) {
        errorObj.rooms = "Rooms must be 1 - 20";
        isValid = false;
      }

      if (config.extraBeds < 0 || config.extraBeds > 6) {
        errorObj.extraBeds = "Extra beds must be 0 - 10";
        isValid = false;
      }

      return errorObj;
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleMealChange = (index, meal) => {
    const updated = [...hotels];
    const updatedErrors = [...errors];

    if (!updatedErrors[index]) updatedErrors[index] = {};

    updated[index] = {
      ...updated[index],
      meals: {
        ...updated[index].meals,
        [meal]: !updated[index].meals?.[meal],
      },
    };

    const { breakfast, lunch, dinner } = updated[index].meals;

    if (!breakfast && !lunch && !dinner) {
      updatedErrors[index].meals = "Please select at least one meal";
    } else {
      updatedErrors[index].meals = "";
    }

    setHotels(updated);
    setErrors(updatedErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    //  Check if user selected ANY hotel
    const hasAnyHotelSelected = hotels.some((h) => h.hotel);

    //  Only validate if at least one hotel is selected
    if (hasAnyHotelSelected && !validateHotelSubmit()) return;

    try {
      //  Only save configs where hotel is selected
      const filteredHotels = hotels.filter(
        (h) => h.hotel && !h.isRemoved
      );

      for (const config of filteredHotels) {
        const payload = {
          ...config,
          packageId,
          _id: undefined,
          isRemoved: undefined,
          nights: Number(config.nights),
          rooms: Number(config.rooms),
          extraBeds: Number(config.extraBeds),
          roomPrice: Number(config.roomPrice),
        };

        await dispatch(addDayHotel(payload)).unwrap();
      }
      nextStep();
    } catch (err) {
      toast.error("Failed to save hotels");
    }
  };

  const hotelsByOption = options.map((option) => ({
    option,
    configs: hotels.filter(
      (h) =>
        String(h.packageOption) === String(option._id) &&
        !h.isRemoved
    ),
  }));

  return (
    <Container>
      <Card className="p-4 shadow-sm border-0 mt-2">
        <Row>
          {hotelsByOption.map(({ option, configs }) => (
            <Col md={6} key={option._id}>
              <Card className="p-3 mb-3 shadow-sm">
                <h5 className="text-center mb-3">{option.name}</h5>

                {configs.map((config) => {
                  const index = hotels.findIndex(
                    (h) =>
                      h.packageOption === config.packageOption &&
                      String(h.dayPlan) ===
                      String(config.dayPlan)
                  );

                  const day = dayPlans.find((d) => d._id === config.dayPlan);

                  return (
                    <Card key={index} className="mb-3 p-3 border">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="mb-0">Day {day?.dayNumber}</h6>

                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          onClick={() => handleRemoveHotel(index)}
                        >
                          Remove
                        </button>
                      </div>

                      <Row className="g-3">
                        {/* Place */}
                        <Col md={6}>
                          <Form.Label>Place</Form.Label>
                          <Select
                            placeholder="Select Place"
                            value={
                              places
                                .map((p) => ({
                                  value: p._id,
                                  label: p.name,
                                }))
                                .find((o) => o.value === config.place) || null
                            }
                            onChange={(selected) =>
                              handleChange(index, "place", selected?.value || "")
                            }
                            options={places.map((p) => ({
                              value: p._id,
                              label: p.name,
                            }))}
                          />
                        </Col>

                        {/* Hotel */}
                        <Col md={6}>
                          <Form.Label>Hotel</Form.Label>
                          <Select
                            placeholder="Select Hotel"
                            isDisabled={!config.place}
                            value={
                              config.hotel
                                ? {
                                  value: config.hotel,
                                  label:
                                    (hotelsMap[index] || [])
                                      .find(
                                        (h) =>
                                          h._id ===
                                          config.hotel
                                      )?.name || "Loading...",
                                }
                                : null
                            }
                            onChange={(selected) =>
                              handleChange(index, "hotel", selected?.value || "")
                            }
                            options={(hotelsMap[index] || []).map((h) => ({
                              value: h._id,
                              label: h.name,
                            }))}
                          />
                        </Col>

                        {/* Room Type */}
                        <Col md={6}>
                          <Form.Label>Room Type</Form.Label>
                          <Form.Select
                            value={config.roomType || ""}
                            disabled={!config.hotel}
                            onChange={(e) =>
                              handleChange(index, "roomType", e.target.value)
                            }
                          >
                            <option value="">Select Room</option>
                            {(roomTypesMap[index] || []).map((rt) => (
                              <option key={rt._id} value={rt._id}>
                                {rt.name} (₹{rt?.basePrice})
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                        <Col md={6}>
                          <Form.Label>Room Price</Form.Label>

                          <Form.Control
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            min={0}
                            step={1}
                            value={config.roomPrice ?? ""}
                            onKeyDown={(e) => {
                              if (["e", "E", "+", "-", "."].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) =>
                              handleChange(index, "roomPrice", e.target.value)
                            }
                          />

                          {errors[index]?.roomPrice && (
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {errors[index].roomPrice}
                            </div>
                          )}
                        </Col>

                        {/* Nights */}

                        {/* Meals */}
                        <Col md={6}>
                          <Form.Label>Meals</Form.Label>

                          <div className="d-flex gap-3">
                            <Form.Check
                              type="checkbox"
                              label="Breakfast"
                              checked={config.meals?.breakfast || false}
                              onChange={() =>
                                handleMealChange(index, "breakfast")
                              }
                            />

                            <Form.Check
                              type="checkbox"
                              label="Lunch"
                              checked={config.meals?.lunch || false}
                              onChange={() => handleMealChange(index, "lunch")}
                            />

                            <Form.Check
                              type="checkbox"
                              label="Dinner"
                              checked={config.meals?.dinner || false}
                              onChange={() => handleMealChange(index, "dinner")}
                            />
                          </div>

                          {errors[index]?.meals && (
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {errors[index].meals}
                            </div>
                          )}
                        </Col>
                        <Col md={12}>
                          <Form.Label>Add-ons</Form.Label>

                          {(() => {
                            const selectedRoom = (roomTypesMap[index] || []).find(
                              (r) => String(r._id) === String(config.roomType)
                            );

                            const availableAddons = selectedRoom?.hotel?.addons || [];
                            const selectedAddons = config.addons || [];

                            if (!config.roomType) {
                              return (
                                <div className="text-muted">
                                  Please select a room type first
                                </div>
                              );
                            }

                            if (availableAddons.length === 0) {
                              return (
                                <div className="text-muted">
                                  No add-ons available
                                </div>
                              );
                            }

                            return availableAddons.map((addon) => {
                              const addonKey = `${addon.name}-${addon.type}-${addon.price}`;

                              const isSelected = (config.addons || []).some(
                                (item) =>
                                  item.name === addon.name &&
                                  item.type === addon.type &&
                                  Number(item.price) === Number(addon.price)
                              );

                              return (
                                <Form.Check
                                  key={addonKey}
                                  type="checkbox"
                                  label={`${addon.name} - ₹${addon.price}`}
                                  checked={isSelected}
                                  onChange={(e) => {
                                    setHotels((prev) => {
                                      const updated = [...prev];

                                      const currentAddons =
                                        updated[index]?.addons || [];

                                      if (e.target.checked) {
                                        const alreadyExists = currentAddons.some(
                                          (item) =>
                                            item.name === addon.name &&
                                            item.type === addon.type &&
                                            Number(item.price) === Number(addon.price)
                                        );

                                        if (!alreadyExists) {
                                          updated[index] = {
                                            ...updated[index],
                                            addons: [
                                              ...currentAddons,
                                              {
                                                addonId: null,
                                                name: addon.name,
                                                type: addon.type,
                                                price: Number(addon.price || 0),
                                                quantity: 1,
                                                isIncluded: true,
                                              },
                                            ],
                                          };
                                        }
                                      } else {
                                        updated[index] = {
                                          ...updated[index],
                                          addons: currentAddons.filter(
                                            (item) =>
                                              !(
                                                item.name === addon.name &&
                                                item.type === addon.type &&
                                                Number(item.price) === Number(addon.price)
                                              )
                                          ),
                                        };
                                      }

                                      return updated;
                                    });
                                  }}
                                />
                              );
                            });
                          })()}
                        </Col>
                      </Row>
                    </Card>
                  );
                })}
              </Card>
            </Col>
          ))}
        </Row>

        <div className="d-flex justify-content-between mt-4 mb-5">
          <button className="cancel-btn" onClick={prevStep}>
            Previous
          </button>


          <button className="submit-btn" onClick={handleSubmit}>
            Next
          </button>
        </div>
      </Card>
    </Container>
  );
}
